<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- Table -->
    <v-server-table
      v-show="load_first"
      ref="privilegesTableComponent"
      :columns="columns"
      :options="option"
      class="jTable table-access-application table-access-privilege"
      @loading="loading"
      @loaded="loaded">

      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="$refs.addPrivilegeModal.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <b-form-select
              v-model="select_type"
              :options="options_search"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        @click="openDetail(props.row)">
        {{ props.row.id }}
      </div>

      <div
        slot="name"
        slot-scope="props"
        @click="openDetail(props.row)">
        <div class="d-flex">
          <div class="td">
            <b-img
              v-if="props.row.photo_url"
              :src="props.row.photo_url"
              rounded="circle"
              alt="img"
              class="m-1 round-bordered-img
              img-circle staff-img image-popup-link b-page-theme td"/>
            <b-img
              v-else
              :src="require('@/assets/logo/user1.png')"
              rounded="circle"
              alt="img"
              class="m-1 round-bordered-img
              img-circle staff-img image-popup-link b-page-theme td"/>
          </div>
          <div class="td p__t--7">
            <div class="f--14">{{ props.row.organigram_name }}</div>
            <div>{{ props.row.employee_name }}</div>
          </div>
        </div>
      </div>

      <div
        slot="email"
        slot-scope="props"
        @click="openDetail(props.row)">
        {{ props.row.email }}
      </div>

      <div
        slot="action"
        slot-scope="props">
        <div
          class="action-table-access-application"
          @click="viewAccess(props.row)">
          View Access
        </div>
      </div>

      <div
        slot="created_at"
        slot-scope="props"
        @click="openDetail(props.row)">
        {{ convertDateTime(props.row.created_at) }}
      </div>

      <div
        slot="updated_at"
        slot-scope="props"
        @click="openDetail(props.row)">
        {{ convertDateTime(props.row.updated_at) }}
      </div>

      <div
        slot="delete"
        slot-scope="props">
        <i
          class="fa fa-lg fa-trash cursor-pointer"
          @click="deleteUser(props.row)"
        />
      </div>
    </v-server-table>

    <jLoadingTable v-if="!load_first"/>

    <!-- Popup add privilege -->
    <b-modal
      ref="addPrivilegeModal"
      class="mod-form modal-access"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div
        v-if="isViewAccess"
        class="close-modal-oos"
        @click="closeAddPrivilege">X</div>
      <div class="label-create-form-data">{{ isViewAccess ? 'VIEW ACCESS' : 'ADD PRIVILEGES' }}</div>
      <div v-if="!isViewAccess">
        <b-form-group>
          <label>Position Name</label>
          <j-single-select
            v-model="user_organigram"
            :is-async="true"
            :cache-options="false"
            :load-options="loadUserOptions"
            :placeholder="'Select'"
            :error-required="false"
            value-format="object"
            label="name"
          />
        </b-form-group>
        <b-row
          v-if="user_organigram && user_organigram.user && user_organigram.user.profile"
          class="rectangle-rule-access">
          <b-col md="1">
            <img
              v-if="user_organigram.user.profile.photo_url"
              :title="user_organigram.user.profile.first_name"
              :src="user_organigram.user.profile.photo_url"
              class="card-assignee-photo-modal">
            <span
              v-else
              :title="user_organigram.user.profile.first_name"
              class="card-assignee-initial-modal">
              {{ getUserInitial(user_organigram.user.profile) }}
            </span>
          </b-col>
          <b-col md="11">
            <span class="label-position">{{ user_organigram.user.profile.first_name }} {{ user_organigram.user.profile.last_name }}</span> <br>
            {{ user_organigram.user.profile.email }}
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row
          v-if="user_organigram && user_organigram.user && user_organigram.user.profile"
          class="rectangle-rule-view-access">
          <b-col md="1">
            <img
              v-if="user_organigram.user.profile.photo_url"
              :title="user_organigram.user.profile.first_name"
              :src="user_organigram.user.profile.photo_url"
              class="card-assignee-photo-modal">
            <img
              v-else
              :title="user_organigram.user.profile.first_name"
              :src="require('@/assets/logo/user1.png')"
              class="card-assignee-photo-modal">
          </b-col>
          <b-col md="11">
            <span class="label-position">{{ user_organigram.user.profile.first_name }} {{ user_organigram.user.profile.last_name }}</span>
            <br v-if="user_organigram.user.profile.first_name || user_organigram.user.profile.last_name" >
            {{ user_organigram.name }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6">
            <div class="label-pages-privileges">PAGES</div>
          </b-col>
          <b-col md="6">
            <span
              class="enable-pages-privileges pull-right"
              @click="disableAll">Disable All</span>
            <span
              class="enable-pages-privileges pull-right m__r--10"
              @click="enableAll">Enable All</span>
          </b-col>
        </b-row>
        <jPagesList
          v-if="listPages.length > 0"
          :list-pages="listPages"
          type="privilege"
          @change-toggle="changeToggle"
        />
      </div>
      <b-row
        v-if="!isViewAccess"
        class="m__t--5">
        <b-col md="6">
          <!-- <b-button
            v-if="isViewAccess"
            class="btn red"
            @click="deletePrivilege">
            Delete
          </b-button> -->
        </b-col>
        <b-col md="6">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeAddPrivilege">
              Close
            </b-button>
            <b-button
              :disabled="!user_organigram"
              class="btn blue"
              @click="confirmPrivilege">
              Confirm
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <j-progress
      ref="progressMappingPage"
      :data-kirim="data_selected"
      :url-api="url_mapping_page"
      :headers="headers"
      @finish="finishActionPage"/>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

import jProgress from '@/components/progress-screen/jProgress';
import jPagesList from '@/views/access/components/jPagesList';
import jApiUser from '@/services/jApiUser';
import jApiPrivilege from '@/services/jApiPrivilege';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import Vue from 'vue';

export default {
  components: {
    jProgress,
    jPagesList,
    jLoadingTable,
  },

  data() {
    return {
      load_first: false,
      filter_data: '',
      select_type: 'organigram_name',
      user_organigram: null,
      data_table: [],
      listPages: [],
      data_selected: [],
      isViewAccess: false,
      privilegesId: 0,
      options_search: [
        {
          text: 'Position ID',
          value: 'organigram_id',
        },
        {
          text: 'Position Name',
          value: 'organigram_name',
        },
      ],
      columns: ['organigram_id', 'name', 'email', 'action', 'created_at', 'updated_at', 'delete'],
      option: {
        headings: {
          organigram_id: 'POSITION ID',
          name: 'POSITION NAME',
          email: 'EMAIL',
          action: 'ACTION',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
          delete: 'DELETE',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
            column: data.column,
            sort: data.sort,
            query: data.query,
            query_type: data.query_type,
            application_id: data.application_id,
          };
        },
        requestFunction(data) {
          const list = jApiPrivilege.getListPrivilegeApp(data);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
      url_mapping_page: '/dynamic-apps/studio/privilege-pages-by-organigram',
    };
  },

  computed: {
    ...mapState('jStorePrivilege', ['priv_app_list']),

    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },

  watch: {
    filter_data(val) {
      if (!val) this.$refs.privilegesTableComponent.refresh();
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },

  created() {
    this.getApplicationDetail();
    // this.getPrivilegeApp();
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreSetting', ['actionGetApplicationDetail']),
    ...mapActions('jStorePrivilege', ['actionGetPrivilegeApp']),
    ...mapActions('jStorePrivilegePage', ['actionGetPrivilegePage', 'actionGetPrivilegePages', 'actionCreatePrivilegePage', 'actionCreatePrivilegeApp', 'actionDeletePrivilegeApp', 'actionDeletePrivilegePage']),

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    loading(val) {
      const a = val;
      a.sort = 'asc';
      a.column = 'id';
      a.query = this.filter_data;
      a.query_type = this.select_type;
      a.application_id = this.$route.params.id;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    getPrivilegeApp() {
      this.load_first = true;
      const req = {
        page: 1,
        limit: 0,
        column: 'id',
        sort: 'asc',
        query: this.$route.params.id,
        query_type: 'application_id',
      };
      this.actionGetPrivilegeApp({ params: req });
    },

    getApplicationDetail() {
      const applicationId = this.$route.params.id;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetApplicationDetail({ applicationId, param });
    },

    loadUserOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: 'id',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.data = this.getListTags(reqData, callback);
      }
    },

    getListTags(req, callback) {
      return jApiUser.listOrganigram(req)
        .then((res) => {
          if (typeof res.data.data !== 'undefined') {
            res.data.data.forEach((lab, index) => {
              // eslint-disable-next-line
              res.data.data[index].label = `${lab.id} - ${lab.name}`;
            });
            callback(null, res.data.data);
          }
          return res.data;
        });
    },

    getUserInitial(user) {
      const firstName = user.first_name ? user.first_name[0] : '';
      const lastName = user.last_name ? user.last_name[0] : '';
      const initial = `${firstName}${lastName}`;
      return initial.toUpperCase();
    },

    filter(val) {
      this.$refs.privilegesTableComponent.refresh();
    },

    openDetail(data) {

    },

    viewAccess(data) {
      this.privilegesId = data.id;
      this.isViewAccess = true;
      this.user_organigram = {
        id: data.organigram_id,
        name: data.organigram_name,
        user: {
          profile: {
            first_name: data.employee_name,
            last_name: '',
            photo_url: data.photo_url,
          },
        },
      };
      this.$refs.addPrivilegeModal.show();
      this.getPrivilegePages();
    },

    getPrivilegePages() {
      const params = {
        application_id: Number(this.$route.params.id),
        organigram_id: this.user_organigram.id,
      };
      this.actionGetPrivilegePages({ params }).then((res) => {
        if (!res.error) {
          this.listPages = res.data;
        }
      });
    },

    closeAddPrivilege() {
      this.isViewAccess = false;
      this.user_organigram = null;
      this.$refs.addPrivilegeModal.hide();
    },

    confirmPrivilege() {
      const params = {
        application_id: Number(this.$route.params.id),
        organigram_id: this.user_organigram.id,
      };
      this.actionCreatePrivilegeApp(params).then((res) => {
        if (!res.error) {
          // this.getPrivilegeApp();
          this.$refs.privilegesTableComponent.refresh();
          this.closeAddPrivilege();
        }
      });
    },

    deletePrivilege() {
      this.$swal({
        title: 'Delete Privilege',
        type: 'warning',
        html: 'Are you sure to delete this privilege?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          await this.actionDeletePrivilegeApp(this.privilegesId);
          // this.getPrivilegeApp();
          this.$refs.privilegesTableComponent.refresh();
          this.closeAddPrivilege();
        }
      });
    },

    async changeToggle(event, data) {
      const params = {
        pages_id: Number(data.id),
        organigram_id: this.user_organigram.id,
      };
      if (event) {
        await this.actionCreatePrivilegePage(params);
      } else {
        const req = {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: data.id,
          query_type: 'pages_id',
        };
        this.actionGetPrivilegePage({ params: req }).then((resp) => {
          if (!resp.error) {
            resp.data.forEach((res) => {
              if (res.organigram_id === this.user_organigram.id) {
                this.actionDeletePrivilegePage(res.id);
              }
            });
          }
        });
      }
    },

    enableAll() {
      this.data_selected = [];

      this.listPages.forEach((val) => {
        if (val.type === 'visible') {
          const data = {
            pages_id: Number(val.id),
            organigram_id: this.user_organigram.id,
            action: 'create',
          };

          this.data_selected.push(data);
        }
      });
      this.alertToggle('enable');
    },

    disableAll() {
      this.data_selected = [];

      this.listPages.forEach((pages, index) => {
        if (pages.type === 'visible') {
          const req = {
            page: 1,
            limit: 0,
            column: 'id',
            sort: 'asc',
            query: pages.id,
            query_type: 'pages_id',
          };
          this.actionGetPrivilegePage({ params: req }).then((resp) => {
            if (!resp.error) {
              resp.data.forEach((res) => {
                if (res.organigram_id === this.user_organigram.id) {
                  this.data_selected.push({ id: Number(res.id), action: 'delete' });
                }
              });
            }
          });
          if (this.listPages.length === index + 1) {
            this.alertToggle('disable');
          }
        }
      });
    },

    alertToggle(status) {
      this.$swal({
        title: 'Update Record Pages',
        text: `Are you sure want to ${status} all page?`,
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.listPages = this.listPages.map((e) => { e.active_privilege = status === 'enable'; return e; });
          this.$refs.progressMappingPage.toggleIsVisible();
        }
      });
    },

    finishActionPage() {
      this.getPrivilegePages();
    },

    deleteUser(data) {
      this.$swal({
        title: 'Remove User from Application',
        text: 'Are you sure want to remove this user from this application?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.actionDeletePrivilegeApp(data.id).then((res) => {
            if (!res.error) {
              // this.getPrivilegeApp();
              this.$refs.privilegesTableComponent.refresh();
            }
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access/tab/jAccessApplicationTabPrivilege.vue